export const pushDataLayerEvent = (eventName) => {
  if (!eventName || typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event: eventName })
}

export const pushProductionDataLayerEvent = (eventName) => {
  if (process.env.VUE_APP_DEPLOY_ENV !== 'prod') return
  pushDataLayerEvent(eventName)
}
